import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import Button from "../Buttons/Button";

const Drawer = ({
  children,
  isOpen,
  onClose,
  position = "right",
  width = "w-80",
  title,
  titleColor,
  titleBgColor="white",
  showCloseButton = true,
  closeOnOutsideClick = false,
  zIndex = 52, // Added zIndex prop
  bodyGap = true,
}) => {
  const slideDirections = {
    left: { x: "-100%" },
    right: { x: "100%" },
    top: { y: "-100%" },
    bottom: { y: "100%" },
  };

  const isVertical = position === "top" || position === "bottom";

  const handleBackdropClick = (e) => {
    if (closeOnOutsideClick) {
      onClose();
    }
  };

  return (
    <AnimatePresence mode="wait">
      {isOpen && (
        <div className="fixed inset-0 overflow-hidden" style={{ zIndex }}>
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={handleBackdropClick}
            className="fixed inset-0 bg-[#000000]/70 bg-opacity-70 transition-opacity"
          />

          {/* Drawer */}
          <div className="fixed inset-0 overflow-hidden pointer-events-none">
            <div
              className={`absolute inset-0 overflow-hidden ${
                isVertical ? "flex flex-col" : "flex"
              }`}
            >
              <motion.div
                initial={slideDirections[position]}
                animate={{ x: 0, y: 0 }}
                exit={slideDirections[position]}
                transition={{
                  type: "spring",
                  stiffness: 400,
                  damping: 40,
                }}
                className={`
                  ${width}
                  pointer-events-auto
                  bg-white
                  shadow-xl
                  ${position === "right" ? "ml-auto" : ""}
                  ${position === "bottom" ? "mt-auto" : ""}
                  ${isVertical ? "w-full" : "h-full"}
                `}
              >
                {/* Header */}
                {(title || showCloseButton) && (
                  <div
                    className={`flex items-center justify-between bg-${titleBgColor}  border-b ${
                      bodyGap && "px-4 py-2"
                    }`}
                  >
                    {title && (
                      <h2
                        className={`text-xl font-medium text-${
                          titleColor || `gray-900`
                        }`}
                      >
                        {title}
                      </h2>
                    )}
                    {showCloseButton && (
                      <Button
                        type="icon"
                        variant="text"
                        color="black"
                        onClick={onClose}
                        icon={"close"}
                      />
                    )}
                  </div>
                )}

                {/* Content */}
                <div
                  className={`h-[calc(100%-70px)] overflow-y-auto ${
                    bodyGap && "p-4"
                  }`}
                >
                  {children}
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default Drawer;
